import { useEffect, useState } from "react";
import { BREAKPOINTS } from "../breakpoints.js";

const getMaxWidthQuery = (breakpoint) => {
  const maxWidth = BREAKPOINTS[breakpoint] ?? BREAKPOINTS.md;
  return `(max-width: ${maxWidth}px)`;
};

/**
 * Returns true when the viewport width is at or below the given breakpoint.
 * @param {keyof typeof BREAKPOINTS} breakpoint - defaults to `md` (768px)
 */
export function useBreakpoint(breakpoint = "md") {
  const query = getMaxWidthQuery(breakpoint);

  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
}

/** Viewport width <= 768px */
export function useIsMobile() {
  return useBreakpoint("md");
}

/** Viewport width <= 1024px */
export function useIsTablet() {
  return useBreakpoint("lg");
}
